import type { DeathShown } from "./death-screen.ts";

/**
 * The death screen's remark: one line said of the death under what it cost. No death has one today, so the screen
 * draws no place for it; the lines are the author's to write (row P2.5-T21), and they arrive here without a change to
 * the screen's layout.
 */

/**
 * The remark for the death the screen shows.
 *
 * @param _shown The screen, which a pool of lines will choose by.
 * @returns The line, or null for none, which is every death today.
 * @example
 * deathRemark(screen.getSnapshot());
 * // null
 */
export function deathRemark(_shown: DeathShown): string | null {
  return null;
}
